const Increase = ({Increase}) => {

    
    return (<>
        <button onClick={Increase}>
            +
        </button>
    </>)
}


export default Increase